import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { SetComponentId } from "../../redux/counterSlice";
import { roles } from "../../utils/constants";
import PositionalPrice from "./PositionalPrice";
import AlphaPositionalPrice from "./AlphaPositionalPrice";
import ClassifiedPositionalPrice from "./ClassifiedPositionalPrice";
import LocalPackageCardLists from "./LocalPackageCardLists";
import ZonePoisitionalPrice from "./ZonePoisitionalPrice";

function UnifiedPositionalPrice() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(80));

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("positional");

  useEffect(() => {
    if (
      localStorage.getItem("role") !== roles.ops &&
      localStorage.getItem("role") !== roles.financer &&
      localStorage.getItem("role") !== roles.salesperson
    )
      navigate("/pagenotfound");
  }, [navigate]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Card Lists Management</h4>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="flex items-center gap-3 justify-between">
            <sl-tab-group onSlTabShow={(e) => handleTabChange(e.detail.name)} class="w-full">
              <sl-tab slot="nav" panel="positional" onClick={() => handleTabChange("positional")}>
                Local Card Lists
              </sl-tab>
              <sl-tab slot="nav" panel="alpha" onClick={() => handleTabChange("alpha")}>
                Alpha Card Lists
              </sl-tab>
              <sl-tab slot="nav" panel="classified" onClick={() => handleTabChange("classified")}>
                Classified Card Lists
              </sl-tab>
              <sl-tab slot="nav" panel="local_package" onClick={() => handleTabChange("local_package")}>
                Local Package Card Lists
              </sl-tab>
              <sl-tab slot="nav" panel="zone" onClick={() => handleTabChange("zone")}>
                Zone Card Lists
              </sl-tab>

              <sl-tab-panel name="positional">
                {activeTab === "positional" && <PositionalPrice />}
              </sl-tab-panel>
              <sl-tab-panel name="alpha">
                {activeTab === "alpha" && <AlphaPositionalPrice />}
              </sl-tab-panel>
              <sl-tab-panel name="classified">
                {activeTab === "classified" && <ClassifiedPositionalPrice />}
              </sl-tab-panel>
              <sl-tab-panel name="local_package">
                {activeTab === "local_package" && <LocalPackageCardLists />}
              </sl-tab-panel>
              <sl-tab-panel name="zone">
                {activeTab === "zone" && <ZonePoisitionalPrice />}
              </sl-tab-panel>
            </sl-tab-group>
          </div>
        </div>
      </div>
    </>
  );
}

export default UnifiedPositionalPrice; 